var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.9999 11.4976C12.9705 11.9852 13.8026 12.7677 14.4101 13.7461C14.5303 13.9399 14.5905 14.0368 14.6113 14.1709C14.6535 14.4435 14.4671 14.7787 14.2132 14.8866C14.0882 14.9397 13.9477 14.9397 13.6666 14.9397M10.6666 8.62786C11.6544 8.13696 12.3332 7.1176 12.3332 5.9397C12.3332 4.76179 11.6544 3.74244 10.6666 3.25154M9.33322 5.9397C9.33322 7.59655 7.99008 8.9397 6.33322 8.9397C4.67637 8.9397 3.33322 7.59655 3.33322 5.9397C3.33322 4.28284 4.67637 2.9397 6.33322 2.9397C7.99008 2.9397 9.33322 4.28284 9.33322 5.9397ZM1.70604 13.5653C2.76892 11.9694 4.44614 10.9397 6.33322 10.9397C8.22031 10.9397 9.89753 11.9694 10.9604 13.5653C11.1932 13.9149 11.3097 14.0897 11.2963 14.313C11.2858 14.4868 11.1719 14.6997 11.0329 14.8048C10.8545 14.9397 10.6091 14.9397 10.1183 14.9397H2.54813C2.05734 14.9397 1.81194 14.9397 1.63352 14.8048C1.49459 14.6997 1.38062 14.4868 1.37018 14.313C1.35678 14.0897 1.4732 13.9149 1.70604 13.5653Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers03);
export default __webpack_public_path__ + "static/media/users-03.a86a996358466aa3912ae5f6c3cc70b7.svg";
export { ForwardRef as ReactComponent };